export default __webpack_public_path__ + "static/Exo2-Regular-921b36cd3c7621bd283b858428e81a57.ttf";